export class Challenge {
  static NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED';
  static SMS_MFA = 'SMS_MFA';
  static TOTP_MFA = 'SOFTWARE_TOKEN_MFA';
  static PASSWORD_EXPIRED = 'PASSWORD_EXPIRED';
  static NPS_EXPIRED = 'NPS_EXPIRED';
  static MFA_SELF_REGISTRATION = 'SELF_REG_MFA_REQUIRED';

  name: string;
  session?: string;

  constructor(name: string, session?: string) {
    this.name = name;
    this.session = session;
  }

  isNewPasswordRequired() {
    return this.name === Challenge.NEW_PASSWORD_REQUIRED;
  }

  isSMS_MFA() {
    return this.name === Challenge.SMS_MFA;
  }

  isTOTP_MFA() {
    return this.name === Challenge.TOTP_MFA;
  }

  isPasswordExpired() {
    return this.name === Challenge.PASSWORD_EXPIRED;
  }
  isNpsExpired() {
    return this.name === Challenge.NPS_EXPIRED;
  }
  isMfaSelfRegistration() {
    return this.name === Challenge.MFA_SELF_REGISTRATION;
  }
}
